// Actions
import { onClientCreditSettingChange } from "../../../redux/pages/clientsPage/clientsPageActions";

// Components
// Boxes
import ClientCreditSettingBox from "./clientCreditSettingBox";
// Dialogs
import AlertDialog from "../../dialogs/alertDialog";
// Menus
import ClientCreditSettingActionMenu from "../../menus/clientsPage/clientCreditSettingActionMenu";

// Configs
import stylesConfig from "../../../configs/stylesConfig";

// Custom Hooks
import { useLanguage } from "../../../customHooks/getLanguage";

// Fetches
import {
  deleteOrRestoreClientCreditSettingFetch,
  editClientCreditSettingSetIsDefaultFetch,
  getAllClientCreditSettingsFetch,
} from "../../../fetches/clientCreditSettingFetches";

// Material UI
// Components
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
// Icons
import AddRoundedIcon from "@mui/icons-material/AddRounded";

// React
import { useEffect, useState } from "react";

// React-Redux
import { useDispatch, useSelector } from "react-redux";

// Styles
import { useStandardItemBoxesContainerStyles } from "../../../styles/componentStyles/boxStyles/standardItemBoxesContainerStyles";

function ClientCreditSettingBoxesContainer() {
  // Hooks
  // Languages
  const t = useLanguage();
  // Styles
  const classes = useStandardItemBoxesContainerStyles();
  // Redux
  const dispatch = useDispatch();

  // Redux Store
  const clientCreditSettingId = useSelector(
    (state) => state.clientsPage.clientCreditSettingId
  );
  const formSubmitCount = useSelector(
    (state) => state.clientsPage.formSubmitCount
  );
  const token = useSelector((state) => state.staff.token);
  const typeOfClientSettings = useSelector(
    (state) => state.clientsPage.typeOfClientSettings
  );

  // States
  // Data
  const [clientCreditSettings, setClientCreditSettings] = useState(null);
  // Dialog
  const [
    clientCreditSettingActionDialogText,
    setClientCreditSettingActionDialogText,
  ] = useState("");
  const [
    clientCreditSettingActionDialogType,
    setClientCreditSettingActionDialogType,
  ] = useState(null);
  const [
    showClientCreditSettingActionDialog,
    setShowClientCreditSettingActionDialog,
  ] = useState(false);
  // Hover
  const [hoveredItemId, setHoveredItemId] = useState(null);
  // Menu
  const [
    showClientCreditSettingActionMenu,
    setShowClientCreditSettingActionMenu,
  ] = useState(null);
  // Render
  const [selectedClientCreditSetting, setSelectedClientCreditSetting] =
    useState(null);

  // Handle States
  const currentItemId = clientCreditSettingId;
  const itemsArr = clientCreditSettings;

  // Events
  // Events - Box
  const onItemClicked = (itemId) => {
    // Update Redux Store
    dispatch(onClientCreditSettingChange(itemId));
  };

  const onItemRightClicked = (item, currentTarget) => {
    onItemClicked(item.id);
    // Set States
    setSelectedClientCreditSetting(item);
    setShowClientCreditSettingActionMenu(currentTarget);
  };

  const onItemShowMenuBtnClicked = (item, currentTarget) => {
    onItemClicked(item.id);
    // Set States
    setSelectedClientCreditSetting(item);
    setShowClientCreditSettingActionMenu(currentTarget);
  };

  // Events - Dialogs
  const onClientCreditSettingActionDialogCanceled = () => {
    // Set States
    setShowClientCreditSettingActionDialog(false);
  };

  const onClientCreditSettingActionDialogConfirmed = () => {
    switch (clientCreditSettingActionDialogType) {
      // 刪除
      case "DeleteClientCreditSetting":
        deleteOrRestoreClientCreditSetting();
        break;
      // 設為一般選項
      case "RemoveClientCreditSettingDefault":
        editClientCreditSettingSetIsDefault();
        break;
      // 還原
      case "RestoreClientCreditSetting":
        deleteOrRestoreClientCreditSetting();
        break;
      // 設為預設選項
      case "SetClientCreditSettingDefault":
        editClientCreditSettingSetIsDefault();
        break;
      default:
        break;
    }

    // Set States
    setShowClientCreditSettingActionDialog(false);
  };

  // Events - Hover
  const onMouseEnterItem = (itemId) => {
    // Set States
    setHoveredItemId(itemId);
  };

  const onMouseLeaveItem = () => {
    // Set States
    setHoveredItemId(null);
  };

  // Events - Title
  const onAddItemBtnClicked = () => {
    // Update Redux Store
    dispatch(onClientCreditSettingChange(null));
  };

  // Functions
  // Functions - Normal
  const displayClientCreditSettingActionDialog = (
    clientCreditSettingActionType
  ) => {
    // Set States
    setClientCreditSettingActionDialogType(clientCreditSettingActionType);

    switch (clientCreditSettingActionType) {
      // 刪除
      case "DeleteClientCreditSetting":
        setClientCreditSettingActionDialogText(
          t("確認要刪除 客戶信用設定 嗎？")
        );
        break;
      // 設為一般選項
      case "RemoveClientCreditSettingDefault":
        setClientCreditSettingActionDialogText(t("確認要設為 一般選項 嗎？"));
        break;
      // 還原
      case "RestoreClientCreditSetting":
        setClientCreditSettingActionDialogText(
          t("確認要還原 客戶信用設定 嗎？")
        );
        break;
      // 設為預設選項
      case "SetClientCreditSettingDefault":
        setClientCreditSettingActionDialogText(t("確認要設為 預設選項 嗎？"));
        break;
      default:
        break;
    }

    // Set States
    setShowClientCreditSettingActionDialog(true);
  };

  // Functions - Mutations
  const deleteOrRestoreClientCreditSetting = async () => {
    const results = await deleteOrRestoreClientCreditSettingFetch(
      token,
      currentItemId,
      typeOfClientSettings
    );

    if (results.success) {
      getAllClientCreditSettings(true);
    }
  };

  const editClientCreditSettingSetIsDefault = async () => {
    const results = await editClientCreditSettingSetIsDefaultFetch(
      token,
      currentItemId,
      !selectedClientCreditSetting.is_default
    );

    if (results.success) {
      getAllClientCreditSettings(false);
    }
  };

  // Functions - Queries
  const getAllClientCreditSettings = async (
    shoulddUpdateCurrentClientCreditSettingId
  ) => {
    const results = await getAllClientCreditSettingsFetch(
      token,
      typeOfClientSettings
    );

    // Set States
    setClientCreditSettings(
      results.clientCreditSettings ? results.clientCreditSettings : null
    );

    // Update Redux Store
    if (shoulddUpdateCurrentClientCreditSettingId) {
      dispatch(
        onClientCreditSettingChange(
          results.clientCreditSettings
            ? results.clientCreditSettings[0].id
            : null
        )
      );
    }
  };

  // Life Cycle
  useEffect(() => {
    getAllClientCreditSettings(clientCreditSettingId ? false : true);
  }, [formSubmitCount, typeOfClientSettings]);

  return (
    <div className={classes.contentBox}>
      {/* Dialog */}
      <AlertDialog
        // Events
        onDialogClosed={onClientCreditSettingActionDialogCanceled}
        onDialogConfirmed={onClientCreditSettingActionDialogConfirmed}
        // States
        dialogText={clientCreditSettingActionDialogText}
        showDialog={showClientCreditSettingActionDialog}
      />
      {/* Menu */}
      <ClientCreditSettingActionMenu
        // States
        selectedClientCreditSetting={selectedClientCreditSetting}
        showClientCreditSettingActionMenu={showClientCreditSettingActionMenu}
        // Set States
        setSelectedClientCreditSetting={setSelectedClientCreditSetting}
        setShowClientCreditSettingActionMenu={
          setShowClientCreditSettingActionMenu
        }
        setClientCreditSettingActionDialogType={
          setClientCreditSettingActionDialogType
        }
        // Functions
        displayClientCreditSettingActionDialog={
          displayClientCreditSettingActionDialog
        }
      />
      {/* ClientCreditSetting */}
      <div className={classes.titleContainer}>
        <div className={classes.titleTextContainer}>
          <Typography variant="h6" align={"left"}>
            {t("客戶信用設定s")}
          </Typography>
          <Tooltip placement="right" title={t("新增客戶信用設定")}>
            <IconButton color={"primary"} onClick={onAddItemBtnClicked}>
              <AddRoundedIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      {/* List */}
      {itemsArr ? (
        itemsArr.map((item) => (
          <ClientCreditSettingBox
            key={item.id}
            // States
            currentItemId={currentItemId}
            hoveredItemId={hoveredItemId}
            item={item}
            // Events
            onItemClicked={onItemClicked}
            onItemRightClicked={onItemRightClicked}
            onItemShowMenuBtnClicked={onItemShowMenuBtnClicked}
            onMouseEnterItem={onMouseEnterItem}
            onMouseLeaveItem={onMouseLeaveItem}
          />
        ))
      ) : (
        <div className={classes.emptyDataContainer}>
          <Typography align={"center"} color={stylesConfig.greyTextColor}>
            {t("未有客戶信用設定資料")}
          </Typography>
        </div>
      )}
    </div>
  );
}

export default ClientCreditSettingBoxesContainer;
